<template lang="pug">
  .job-menu(:class="{ active: checked || isUploaded || isUploading }")
    p(v-if="checkedCount > 0")
      span(v-if="spMode") {{ checkedCount }}件のリストを選択
      span(v-else) {{ checkedCount }}件のリストを一覧から選択しています。
      span
        a(@click="uncheckAll") チェック解除
    p.more-dl-message(v-if="checkedCount > 0")
      | 1度のダウンロードは{{ jobCsvDownloadLimit.toLocaleString() }}件までできます
    ul
      li
        a.only-pc.button-sub(
          v-if="checkedCount > 0"
          @click="openCsvDownloadModal"
          :disabled="disabled"
        ) ダウンロード

      li(v-if="checkedCount > 0")
        a.button-sub(@click="addToMyList" :disabled="disabled") 求人リスト追加

      li(v-if="manuscriptAi && checkedCount > 0")
        a.button-sub(@click="openAiManuscriptModal" :disabled="aiDisabled") AI原稿生成
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { HumanErrorMessages, HumanInfoMessages } from '../../constants'

export default {
  props: ['checkedIds'],
  computed: {
    ...mapGetters('job', ['checked', 'checkedCount']),
    ...mapGetters('common', ['spMode', 'downloading']),
    ...mapGetters('user', ['demo', 'manuscriptAi', 'jobCsvDownloadLimit']),
    ...mapGetters('uploadArchive', ['latestId', 'isUploading', 'isUploaded']),
    ...mapGetters({ locked: 'common/isGlobalLocked' }),
    disabled () {
      return this.locked || this.downloading
    },
    aiDisabled () {
      return this.disabled || this.checkedCount === 0 || this.checkedCount > 3
    },
  },
  async mounted () {
    try {
      await this.$store.dispatch('uploadArchive/fetchLatest', { target: 'job' })
      if (this.isUploading) await this.$store.dispatch('uploadArchive/startWatch', { target: 'job' })
    } catch (e) {
      // 失敗は無視（必要なら toast）
    }

    if (this.isUploading) await this.$store.dispatch('uploadArchive/startWatch', { target: 'job' })
  },
  methods: {
    ...mapActions('job', ['removeCheckedJobs']),
    ...mapMutations('job', ['uncheckAll', 'clearDetail']),
    openCsvDownloadModal () {
      if (this.demo) {
        this.$store.dispatch('common/pushToastError', {
          error: new Error(HumanErrorMessages.FORBIDDEN),
        })
        return
      }
      if (this.isUploading) return
      if (this.checkedCount > 0) {
        this.$store.commit('common/setCsvTarget', 'job')
        this.$emit('setJobModalMode')
        this.$store.commit('common/showModal')
      }
    },
    async downloadFromS3 () {
      try {
        await this.$store.dispatch('uploadArchive/download', { target: 'job' })
      } catch (e) {
        await this.$store.dispatch('common/pushToastError', { error: e })
      }
    },
    async addToMyList () {
      this.clearDetail()
      this.$store.commit('common/lockGlobal')
      const ids = this.checkedIds
      try {
        await this.$store.dispatch('jobList/add', { ids })
        this.$store.commit('job/uncheck', ids)
        this.$store.commit('job/favor', { ids, newFavored: true })
        await this.$store.dispatch('common/pushToastInfo', {
          info: HumanInfoMessages.ADDED_TO_MYLIST,
        })
      } catch (e) {
        this.$store.dispatch('common/pushToastError', { error: e })
      } finally {
        this.$store.commit('common/unlockGlobal')
      }
    },
    openAiManuscriptModal () {
      if (this.demo) {
        this.$store.dispatch('common/pushToastError', {
          error: new Error(HumanErrorMessages.FORBIDDEN),
        })
        return
      }
      if (this.checkedCount === 1) {
        this.$store.commit('job/showAiModal')
      } else if (this.checkedCount > 1) {
        // eslint-disable-next-line no-alert
        alert('AI原稿生成は、求人選択は1つまでとなります')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/parts/JobMenu.vue